import React from 'react';
import AssetTable from '../components/AssetTable';

export default function CommoditiesPage() {
  return <AssetTable type="commodity" title="Rohstoffe" icon="fa-solid fa-industry" chartType="stock" />;
}
